import api from "../utils/api";
import {
  CART_ADD_ITEM,
  CART_CLEAR,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  FAVOURITES_ADD_ITEM,
  FAVOURITES_REMOVE_ITEM,
} from "./constants/cart.js";
import { getPatternPricingPresentation } from "../utils/patternPricing";
import { getCartItemKey, getOrderedPatternSizes, normalizePatternSize } from "../utils/patternSize";

export const addToList = (
  id: string,
  type: string = "cart",
  selectedSize?: string | string[]
) => async (
  dispatch: any,
  getState: any
) => {
  const currencyQuery = "?displayCurrency=EUR";
  const {
    data: {
      _id,
      user,
      name,
      price,
      discount,
      photos,
      sizes,
      profileHandle,
      omnibus,
      displayPricing,
      displayOmnibus,
    },
  } = await api.get(`/patterns/id/${id}${currencyQuery}`);
  const orderedSizes = getOrderedPatternSizes(sizes);
  const normalizedRequestedSizes = Array.from(
    new Set(
      (Array.isArray(selectedSize)
        ? selectedSize
        : selectedSize
          ? [selectedSize]
          : []
      )
        .filter((size): size is string => typeof size === "string")
        .map((size) => normalizePatternSize(size))
        .filter(Boolean)
    )
  );
  const resolvedRequestedSizes =
    type === "cart"
      ? normalizedRequestedSizes.length > 0
        ? normalizedRequestedSizes.filter((size) => orderedSizes.includes(size))
        : orderedSizes.length === 1
          ? [orderedSizes[0]]
          : []
      : [];

  if (type === "cart" && orderedSizes.length > 1 && resolvedRequestedSizes.length === 0) {
    return;
  }

  const pricing = getPatternPricingPresentation({
    price,
    discount,
    omnibus,
    displayPricing,
    displayOmnibus,
  });
  const finalPrice = pricing.currentEffectivePrice;

  if (type === "cart") {
    const sizesToAdd = resolvedRequestedSizes.length > 0 ? resolvedRequestedSizes : [""];
    sizesToAdd.forEach((sizeValue) => {
      const payload = {
        id: _id,
        user,
        name,
        price: finalPrice,
        originalPrice: pricing.showPromotionInfo ? pricing.promotionBasePrice : null,
        photo: photos[0],
        sizes,
        selectedSize: sizeValue || null,
        profileHandle,
        omnibusLowestPrice:
          pricing.showOmnibusInfo && pricing.lowestEffectivePrice !== null
            ? pricing.lowestEffectivePrice
            : null,
        showPromotionInfo: pricing.showPromotionInfo,
        showOmnibusInfo: pricing.showOmnibusInfo,
      };
      dispatch({
        type: CART_ADD_ITEM,
        payload: {
          ...payload,
          cartItemId: getCartItemKey(payload),
        },
      });
    });
  } else {
    dispatch({
      type: FAVOURITES_ADD_ITEM,
      payload: {
        id: _id,
        user,
        name,
        price: finalPrice,
        originalPrice: pricing.showPromotionInfo ? pricing.promotionBasePrice : null,
        photo: photos[0],
        sizes,
        selectedSize: null,
        profileHandle,
        omnibusLowestPrice:
          pricing.showOmnibusInfo && pricing.lowestEffectivePrice !== null
            ? pricing.lowestEffectivePrice
            : null,
        showPromotionInfo: pricing.showPromotionInfo,
        showOmnibusInfo: pricing.showOmnibusInfo,
      },
    });
  }

  localStorage.setItem(`${type}Items`, JSON.stringify(getState()[type]));
};
export const removeFromList = (
  id: string,
  type: string = "cart",
  selectedSize?: string | null
) => (
  dispatch: any,
  getState: any
) => {
  const normalizedSize =
    typeof selectedSize === "string" && selectedSize.trim()
      ? normalizePatternSize(selectedSize)
      : null;
  dispatch({
    type: type === "cart" ? CART_REMOVE_ITEM : FAVOURITES_REMOVE_ITEM,
    payload:
      type === "cart"
        ? {
          id,
          selectedSize: normalizedSize,
        }
        : id,
  });
  localStorage.setItem(`${type}Items`, JSON.stringify(getState()[type]));
};

export const savePaymentMethod = (data: any) => (dispatch: any) => {
  dispatch({
    type: CART_SAVE_PAYMENT_METHOD,
    payload: data,
  });
};

export const clearCart = () => (dispatch: any) => {
  dispatch({ type: CART_CLEAR });
};
